import "./App.css";
import AppLayout from "./components/layouts/app-layout/AppLayout";

const App = () => {
  return (
    <div className="App">
      <AppLayout />
    </div>
  );
};

export default App;
